import React from 'react'

function noopAsync() {
  return Promise.resolve()
}

export default function BoundVideoSurface({
  participant,
  videoBinder,
  className = '',
  mirrorVideo = false,
}) {
  const elementRef = React.useRef(null)
  const participantRef = React.useRef(participant)
  const videoHandle = participant?.videoHandle ?? null
  const AttachmentComponent = videoBinder?.AttachmentComponent || null
  const bindingKey =
    participant?.renderKey ||
    videoBinder?.getRenderKey?.(participant) ||
    participant?.id ||
    null

  React.useEffect(() => {
    participantRef.current = participant
  }, [participant])

  React.useEffect(() => {
    if (!videoBinder?.bindVideo || !videoBinder?.unbindVideo || !videoHandle || AttachmentComponent) {
      return undefined
    }

    const element = elementRef.current
    if (!element) {
      return undefined
    }

    const bindVideo = videoBinder.bindVideo || noopAsync
    const unbindVideo = videoBinder.unbindVideo || noopAsync

    Promise.resolve(
      bindVideo({
        element,
        participant: participantRef.current,
        videoHandle,
      }),
    ).catch(() => {})

    return () => {
      Promise.resolve(
        unbindVideo({
          element,
          participant: participantRef.current,
          videoHandle,
        }),
      ).catch(() => {})

      if (element) {
        element.innerHTML = ''
      }
    }
  }, [AttachmentComponent, bindingKey, videoBinder, videoHandle])

  const resolvedClassName = `${className}${mirrorVideo ? ' shared-video-surface--mirror' : ''}`

  if (AttachmentComponent) {
    return (
      <AttachmentComponent
        participant={participant}
        videoHandle={videoHandle}
        className={resolvedClassName}
      />
    )
  }

  return <div ref={elementRef} className={resolvedClassName} />
}

BoundVideoSurface.displayName = 'BoundVideoSurface'
